import { Component, HostListener, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmDialogHeaderComponent, HlmDialogTitleDirective } from '@spartan-ng/ui-dialog-helm';

@Component({
  selector: 'thalea-questionnaire-dialog',
  imports: [
    HlmDialogTitleDirective,
    HlmDialogHeaderComponent,
    HlmButtonDirective,
    ReactiveFormsModule
  ],
  templateUrl: './questionnaire-dialog.component.html',
  styleUrl: './questionnaire-dialog.component.css'
})
export class QuestionnaireDialogComponent {
  /** Function to close the dialog */
  public close = output<void>();

  /** Title of the dialog */
  public title = input<string>("")

  /** Content of the dialog */
  public content = input<string>("")

  /**
   * Closes the dialog.
   */
  public closeDialog(event: Event): void {
    event.stopPropagation();
    this.close.emit();
  }
}
